<script setup>
import { computed } from 'vue';

const props = defineProps({
  secondsRemaining: { type: Number, default: 0 },
  totalSeconds: { type: Number, default: 0 },
});

// // TvP08ProgressCircle setup functions

const RADIUS = 38;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const progressRatio = computed(() => {
  if (!props.totalSeconds) return 0;
  return Math.max(0, Math.min(1, props.secondsRemaining / props.totalSeconds));
});

const dashOffset = computed(() => CIRCUMFERENCE * (1 - progressRatio.value));

// // TvP08ProgressCircle handler functions

// // TvP08ProgressCircle watchers
</script>

<template>
  <div class="tvp-08-progress-circle">
    <svg viewBox="0 0 90 90" class="tvp-08-progress-circle__svg">
      <circle class="tvp-08-progress-circle__track" cx="45" cy="45" :r="RADIUS" />
      <circle
        class="tvp-08-progress-circle__fill"
        cx="45"
        cy="45"
        :r="RADIUS"
        :stroke-dasharray="CIRCUMFERENCE"
        :stroke-dashoffset="dashOffset"
        transform="rotate(-90 45 45)"
      />
    </svg>
    <span class="tvp-08-progress-circle__seconds">{{ secondsRemaining }}</span>
  </div>
</template>

<style scoped lang="scss">
@use './tvp08progresscircle.scss';
</style>
